export const WINDOW_UPDATE_SIZE = 'WINDOW_UPDATE_SIZE'
